var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('p',{staticClass:"product-name font-medium truncate text-center"},[_c('vs-icon',{staticClass:"view_icon",attrs:{"icon-pack":"material-icons","icon":"video_call"},on:{"click":_vm.showCamera}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }